import React from 'react';
import { vacuum, stats } from '../mock';
import Reveal from './Reveal';

const VacuumExcavation = () => {
  return (
    <section className="bg-[#262629] px-5 md:px-10 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-stretch">
        {/* text */}
        <Reveal>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl mb-8">
            <span className="text-yellow">{vacuum.title[0]} {vacuum.title[1]}</span><br />
            <span className="text-yellow">{vacuum.title[2]}</span>
          </h2>
          <p className="text-white/85 text-base md:text-lg leading-relaxed mb-5 max-w-xl">{vacuum.p1}</p>
          <p className="text-white/85 text-base md:text-lg leading-relaxed mb-9 max-w-xl">{vacuum.p2}</p>
          <div className="flex flex-wrap gap-4">
            <a href="/contact" className="bg-jaw-yellow text-[#262629] font-semibold px-8 py-4 rounded-[10px] hover:bg-[#e8660a] transition-colors">
              Get a quote
            </a>
            <a href="/files/core-sample-report.pdf" download target="_blank" rel="noopener noreferrer" className="bg-white text-[#262629] font-semibold px-8 py-4 rounded-[10px] hover:bg-white/85 transition-colors">
              Download a sample report
            </a>
          </div>
        </Reveal>

        {/* media */}
        <Reveal delay={0.15} className="h-full">
          <div className="relative rounded-2xl overflow-hidden h-[280px] sm:h-[380px] lg:h-full lg:min-h-[420px]">
            <img
              src="https://images.unsplash.com/photo-1503387837-b154d5074bd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjBlc3RpbWF0aW5nJTIwYmx1ZXByaW50c3xlbnwwfHx8fDE3ODc1ODQ0MTl8MA&ixlib=rb-4.1.0&q=85"
              alt="Construction estimating from drawings"
              className="w-full h-full object-cover"
            />
          </div>
        </Reveal>
      </div>

      {/* stats marquee */}
      <div className="marquee-wrap mt-16 md:mt-24 overflow-hidden">
        <div className="flex w-max animate-marquee">
          {[...stats, ...stats, ...stats, ...stats].map((s, i) => (
            <div key={i} className="flex items-center shrink-0">
              <span className="font-display text-yellow text-4xl md:text-6xl whitespace-nowrap px-8">{s}</span>
              <span className="w-3 h-3 md:w-4 md:h-4 bg-jaw-yellow rotate-45 rounded-[2px] mx-4 shrink-0" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VacuumExcavation;
